import API from 'utils/api';
import { onError } from 'utils/handlers';

const baseURI = 'nominas/nominas';

const lista = (ids) => (ids || []).join(',') || undefined;

/**
 * GET Periodos, tipos de nómina empleado y tipos de nómina con nóminas autorizadas en el
 * ejercicio (para llenar los selectores del Reporte Acumulado de Percepciones).
 * @param {number} periodoFiscal
 * @returns {Promise<{ periodos: object[], tipos_de_nomina_empleado: object[],
 *   tipos_de_nomina: object[] } | null>}
 */
export const getOpcionesReporteAcumulado = async (periodoFiscal) => {
  try {
    const response = await API.get(`${baseURI}/opciones-reporte-acumulado`, {
      params: { periodo_fiscal: periodoFiscal },
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Reporte Acumulado de Percepciones por Empleado (ficha 198). Listas vacías = todos.
 * @param {{ periodo_fiscal: number, periodos?: number[], tipos_de_nomina_empleado?: number[],
 *   tipos_de_nomina?: number[] }} params
 * @returns {Promise<{ conceptos: object[], filas: object[], totales: number[],
 *   total_general: number, nominas_consideradas: number } | null>}
 */
export const getReporteAcumuladoPercepciones = async (params) => {
  try {
    const response = await API.get(`${baseURI}/reporte-acumulado-percepciones`, {
      params: {
        periodo_fiscal: params.periodo_fiscal,
        periodos: lista(params.periodos),
        tipos_de_nomina_empleado: lista(params.tipos_de_nomina_empleado),
        tipos_de_nomina: lista(params.tipos_de_nomina),
      },
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
